import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CryptoService } from '@stockcare-services/crypto/crypto.service';
import { UserStorageService } from '@stockcare-storage/user/user-storage.service';
import { MatchValidator } from '@stockcare-validators/matchValidator';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '@stockcare-services/notification-service/notification.service';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';

@Component({
  standalone: false,
  selector: 'app-create-pin',
  templateUrl: './create-pin.component.html',
  styleUrls: ['./create-pin.component.scss'],
})
export class CreatePinComponent implements OnInit {
  pinLength: number;
  createPinForm: UntypedFormGroup;

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly modalReference: MatDialogRef<CreatePinComponent>,
    private readonly userStoreageService: UserStorageService,
    private readonly cryptoService: CryptoService,
    private readonly notify: NotificationService,
    private readonly settingsService: SettingsService,
    @Inject(MAT_DIALOG_DATA) private username: string
  ) {}

  ngOnInit() {
    this.pinLength = this.settingsService.getSettingNumber('userPinLength');
    this.createPinForm = this.fb.group({
      pin: [null, [Validators.required, Validators.minLength(this.pinLength)]],
      confirmPin: [null, [Validators.required, MatchValidator('pin')]],
    });
  }

  get controls() {
    return this.createPinForm.controls;
  }

  async createPin() {
    if (this.createPinForm.valid) {
      await this.saveUserPin();
    }
  }

  async saveUserPin() {
    const pin = this.createPinForm.get('pin').value;
    const hashedPin = this.cryptoService.computeSHA256Hash(pin, this.username);
    const foundUser = await this.userStoreageService.getUserByUsername(this.username);
    if (foundUser) {
      await this.userStoreageService.saveUserPin(this.username, hashedPin);
      this.notify.success('Pin created successfully');
      this.modalReference.close(true);
    }
  }

  preventTextInput(event: any) {
    const charCode = event.which || event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
